import { ORCHESTRATION_STATUSES } from './dashboardContants';

export const STATUS_LABELS: Record<string, string> = {
  [ORCHESTRATION_STATUSES.PENDING]: 'Pending',
  [ORCHESTRATION_STATUSES.IN_PROGRESS]: 'In Progress',
  [ORCHESTRATION_STATUSES.FAILED]: 'Failed',
  [ORCHESTRATION_STATUSES.STOPPED]: 'Stopped',
  [ORCHESTRATION_STATUSES.STOPPING]: 'Stopping',
  [ORCHESTRATION_STATUSES.FINISHED]: 'Finished',
  [ORCHESTRATION_STATUSES.FINISHED_ERROR]: 'Finished Error',
};

